<template>
  <v-container fluid>
    <v-row justify="center" class="mt-4"> </v-row>
    <v-row justify="center" class="mt-4">
      <v-col cols="12" class="center">
        <!-- <v-row justify="center" class="mb-2">
          <v-btn
            color="primary"
            :loading="isSaving"
            depressed
            @click="isSaving = true"
          >
            <v-icon left dark>mdi-arrow-down-left</v-icon>

            Descargar Tareas</v-btn
          >
        </v-row> -->
        <br />
        <v-col cols="12" sm="12">
          <v-card>
            <v-form ref="form" lazy-validation>
              <v-card-title class="justify-center"
                ><h4>Listado de Tareas Pendientes</h4>
              </v-card-title>
              <v-row justify="center" class="mb-2">
                <!-- <v-btn color="primary" depressed :disabled="asignarBool">
                  <v-icon left dark>mdi-arrow-down-left</v-icon>

                  Asignar a Cuadrilla</v-btn
                > -->

                <v-data-table
                  :headers="headersTareasAsignadas"
                  :items="tablaTareasAsignadas"
                  :search="buscarTareasAsignadas"
                  :custom-filter="filtrarTareasAsignadas"
                  item-value="Categoria"
                  class="elevation-1 mt-2"
                  no-results-text="No se encontraron resultados"
                  no-data-text="No ha cargado Ningun Dato"
                  :footer-props="$store.state.traduccionTabla"
                >
                  <template v-slot:top>
                    <v-text-field
                      v-model="buscarTareasAsignadas"
                      label="Buscar Tareas Asiganadas"
                      class="pa-2"
                    ></v-text-field>
                  </template>

                  <template v-slot:[`item.actions`]="{ item }">
                    <v-tooltip left>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          elevation="10"
                          small
                          fab
                          color="orange"
                          dark
                          class="mx-2"
                          @click="asignarTareaCuadrilla(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon dark>
                            mdi-account-multiple-plus-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Asignar Tarea a Cuadrilla</span>
                    </v-tooltip>
                  </template>
                </v-data-table>

                <br />
              </v-row>
            </v-form>
          </v-card>
        </v-col>
      </v-col>
      <!-- @click="isSaving = true" -->
    </v-row>
    <AlertSnackBar ref="AlertSnackBar" color="blue"></AlertSnackBar>
    <dialog-mensaje
      ref="dialogMensaje"
      @resultado="asignarTareaCuadrillaConfirmacion"
    />
  </v-container>
</template>
<script>
import axios from "axios";
import dialogMensaje from "@/components/modalMensaje.vue";
export default {
  components: {
    dialogMensaje,
  },
  data() {
    return {
      idCuadrilla: "",
      buscarTareasAsignadas: "",
      buscar: "",
      alertShow: false,
      isSaving: false,
      show1: false,
      asignarBool: true,
      tareasSeleccionadas: [],
      headerProps: {
        sortByText: "Ordenar por",
      },
      footerProps: {
        itemsPerPageText: "Registros por página",
        pageText: "{0}-{1} de {2}",
        itemsPerPageOptions: [5, 10, 20, 50, 100, { text: "Todos", value: -1 }],
      },

      tareas: [
        {
          idTarea: "0",
          descripcion: "O.K.",
        },
        {
          idTarea: "11",
          descripcion: "SUSPENSION FALTA DE PAGO A REALIZAR",
        },
        {
          idTarea: "12",
          descripcion: "SUSPENSION FALTA DE PAGO EXIMIDO",
        },
        {
          idTarea: "13",
          descripcion: "SUSPENSION FALTA DE PAGO A CONFIRMAR",
        },
        {
          idTarea: "14",
          descripcion: "SUSPENSION FALTA DE PAGO AVISO EMITIDO",
        },
        {
          idTarea: "15",
          descripcion: "SUSPENSION FALTA DE PAGO ORDEN EMITIDA",
        },
        {
          idTarea: "16",
          descripcion: "SUSPENSION FALTA DE PAGO ORDEN EJECUTADA",
        },
      ],
      cuadrilla: [],
      tablaTareasAsignadas: [],
      headersTareasAsignadas: [
        { text: "Distrito", value: "distrito", class: "black white--text" },
        { text: "Radio", value: "radio", class: "black white--text" },
        { text: "Recorrido", value: "recorrido", class: "black white--text" },
        { text: "ISN", value: "isn", class: "black white--text" },
        { text: "Indice", value: "indice", class: "black white--text" },
        {
          text: "Identificador",
          value: "identificador",
          class: "black white--text",
        },
        {
          text: "Vencimiento",
          value: "vencimiento",
          class: "black white--text",
        },
        { text: "Titular", value: "titular", class: "black white--text" },
        { text: "Domicilio", value: "domicilio", class: "black white--text" },
        { text: "Barrio", value: "barrio", class: "black white--text" },
        { text: "Medidor", value: "medidor", class: "black white--text" },
        { text: "Motivo", value: "motivo", class: "black white--text" },
        { text: "Detalle", value: "detalle", class: "black white--text" },
        { text: "Comentario", value: "comentario", class: "black white--text" },
        { text: "Telefono", value: "telefono", class: "black white--text" },
        { text: "Mail", value: "mail", class: "black white--text" },
        {
          text: "Contratista",
          value: "contratista",
          class: "black white--text",
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
          class: "black white--text",
        },
      ],
      listaTareasPendientes: [
        {
          cliente: "Frozen Yogurt",
          medidor: 159,
        },
        {
          cliente: "Ice cream sandwich",
          medidor: 237,
        },
        {
          cliente: "Eclair",
          medidor: 262,
        },
        {
          cliente: "Cupcake",
          medidor: 305,
        },
        {
          cliente: "Gingerbread",
          medidor: 356,
        },
        {
          cliente: "Jelly bean",
          medidor: 375,
        },
        {
          cliente: "Lollipop",
          medidor: 392,
        },
        {
          cliente: "Honeycomb",
          medidor: 408,
        },
        {
          cliente: "Donut",
          medidor: 452,
        },
        {
          cliente: "KitKat",
          medidor: 518,
        },
      ],
    };
  },
  watch: {
    isSaving(val) {
      if (val) {
        this.$refs.AlertSnackBar.Abrir("Descargando Tareas...");
        setTimeout(() => (this.isSaving = false), 1500);
      } else {
        //  this.$router.push("Principal");
      }
    },
    tareasSeleccionadas() {
      // console.log(this.tareasSeleccionadas);
      this.asignarBool = !this.tareasSeleccionadas.length > 0;
    },
  },
  mounted() {
    const datos = this.$route.params.datos;
    console.log("Los datos recividos son");
    console.log(datos);
    this.idCuadrilla = datos.idCuadrilla;
    console.log("El id de la cuadrilla es");
    console.log(this.idCuadrilla);
    this.recuperarTareasAsignadasContratista();
  },
  methods: {
    asignarTareaCuadrilla(datosTarea) {
      this.idTarea = datosTarea.idTarea;
      //this.idCuadrilla = datosTarea.idCuadrilla;
      console.log(this.idTarea);
      console.log(this.idCuadrilla);
      console.log(this.$store.getters.usuario.idContratista);
      this.$refs.dialogMensaje.abrirMensajeDialog(
        "Desea asignar la tarea a la cuadrilla ?",
        2,
        "orange",
        "Aviso"
      );
    },

    async asignarTareaCuadrillaConfirmacion(confirmacion) {
      if (confirmacion == true) {
        console.log("El token es");
        console.log(this.$store.getters.usuario.token);

        this.url = this.$store.getters.urlBase + "Task/ingresarTareaCuadrilla";

        // const config = {
        //   headers: {
        //     Authorization: `Bearer ${this.$store.getters.usuario.token}`,
        //   },
        // };

        console.log("El id de la cuadrilla es ");
        console.log(this.cuadrillaSeleccion);

        const data = {
          idTarea: this.idTarea,
          idCuadrilla: this.idCuadrilla,
          idUsuario: this.$store.getters.usuario.user_id,
        };

        console.log("Los datos para ingresar tarea son: ");
        console.log(data);

        //var listacontratista = [];
        //this.contratistas = listacontratista;

        var respuesta = await axios
          .post(this.url, data)
          .then((response) => {
            console.log("La lista de tareas del contratista es: ");
            console.log(response);
            return response;
            //this.contratistas = response.data;
          })
          .catch((error) => {
            console.log(error.response);
            if (error.response == undefined) {
              this.mensajeSnack = "Error de Conexion";
            } else {
              if (error.response.status === 401) {
                this.mensajeSnack =
                  "No posee autorizacion para ver esta informacion";
              } else {
                if (error.response.data != "") {
                  this.mensajeSnack = error.response.data;
                }
              }
            }
            this.loadingButton = false;
            this.colorSnack = "red";
            this.Showsnackbar = true;
            return null;
          });

        console.log("La respuesta es");
        console.log(respuesta);

        if (respuesta.status == 200) {
          this.mensajeDelDialog = respuesta.data;

          var mensajeDialog = "";
          if (this.mensajeDelDialog == true) {
            mensajeDialog = "Operacion Exitosa";
          } else {
            mensajeDialog = "Operacion Rechazada";
          }

          this.$refs.dialogMensaje.abrirMensajeDialog(
            mensajeDialog,
            1,
            this.mensajeDelDialog == true ? "green" : "red",
            "Informacion"
          );
        } else {
          console.log("Ingreso en el else de la respuesta");
          this.$refs.dialogMensaje.abrirMensajeDialog(respuesta.Error, 1);
          this.mensajeDelDialog = respuesta.Error;
          this.mensajeDelDialog = respuesta.Error.split("-");
          this.colorDialog = "red";
          this.dialog = true;
        }

        if (this.bandera == 1) {
          console.log("Ingresoe en la bandera 1 para ocultar el dialog");
          this.dialog = false;
        }

        //this.loadingButton = false;

        this.$router.push("/Cuadrillas");
      }
    },

    // asignarTareaCuadrilla(datos) {
    //   console.log("Ingreso en asignar tarea");
    //   this.$refs.abrirModalInsert_Update.asignarTareaCuadrilla(datos);
    // },

    filtrarTareasAsignadas(value, query) {
      return (
        value != null &&
        query != null &&
        typeof value === "string" &&
        value.toString().toLowerCase().includes(query.toLowerCase())
      );
    },

    orderList() {
      this.list = this.list.sort((one, two) => {
        return one.order - two.order;
      });
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },
    async recuperarTareasAsignadasContratista() {
      var respuesta;
      this.tablaTareasAsignadas = [];

      console.log("Igreso recuperarTareasAsignadasContratista");

      this.url =
        this.$store.state.urlBase +
        "Task/recuperarTareasAsignadasContratistas?idContratista=" +
        this.$store.getters.usuario.idContratista;

      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("Token")}`,
        },
      };

      const data = {
        idContratista: this.$store.getters.usuario.idContratista,
      };

      console.log(data);

      respuesta = await axios
        .get(this.url, config, data)
        .then((response) => response.data);

      console.log("El resultado de la respuesta de las tareas asignadas es:");

      this.tablaTareasAsignadas = respuesta;

      console.log(this.tablaTareasAsignadas);
    },
  },
};
</script>
